;(function(define){
    'use strict'
    define( 'es6ish-class/lib/create',['require','exports','module'],function( require, exports, module ){
        'use strict'
    	return Object.create || function( obj ){
    	      function F() {}
    	      F.prototype = obj;
    	      return new F()
        };
    });
})(typeof module === 'object' && module.exports && typeof define !== 'function'
    ? function (factory) { module.exports = factory(require, exports, module); }
    : define
);
